import { useState } from "react";



export const userColumns = [
  { field: "id", headerName: "ID", width: 230 },
  {
    field: "user",
    headerName: "User",
    width: 230,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          {params.row.username}
        </div>
      );
    },
  },
  {
    field: "email",
    headerName: "Email",
    width: 230,
  },
  {
    field: "phonenumber",
    headerName: "Phone Number",
    width: 230,
  },
  {
    field: "address",
    headerName: "Address",
    width: 230,
  }

  // {
  //   field: "age",
  //   headerName: "Age",
  //   width: 100,
  // },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];

export const roomsColumns = [
  { field: "id", headerName: "ID", width: 70 },

  
  
  {
    field: "name",
    headerName: "Name",
    width: 230,
    // renderCell: (params) => {
    //   return (
    //     <div className="cellWithImg">
    //       {/* <img className="cellImg" src={params.row.img} alt="avatar" /> */}
    //       {params.row.roomname}
    //     </div>
    //   );
    // },
  },
  // {
  //   field: "email",
  //   headerName: "Email",
  //   width: 230,
  // },

  {
    field: "price",
    headerName: "Price",
    width: 100,
  },
  
];


//temporary data

//Rooms
export const roomsRows = [
  {
    id: 1,
    roomname: "Small Room",
    status: true,
    price: "$70",
    isMoney: true
  },
  {
    id: 2,
    roomname: "Big Room",
    status: false,
    price: "$100",
    isMoney: true
  },
  
];


//Users
// export const userRows = [
//   {
//     id: 1,
//     username: "Jordan",
//     // status: "active",
//     email: "aaa@yahoo.fr",
//     age: 25,
//   },
//   {
//     id: 2,
//     username: "Alexandre",
//     email: "aaaa@gmail.com",
//     // status: "passive",
//     age: 62,
//   },
//   {
//     id: 3,
//     username: "Natali",
//     email: "aaa@gmail.com",
//     // status: "pending",
//     age: 45,
//   },
//   {
//     id: 4,
//     username: "Stark",
//     email: "aaa@gmail.com",
//     // status: "active",
//     age: 16,
//   },
//   {
//     id: 5,
//     username: "Poutine",
//     email: "aaa@gmail.com",
//     // status: "passive",
//     age: 22,
//   },
//   {
//     id: 6,
//     username: "Beli",
//     email: "aaaa@gmail.com",
//     // status: "active",
//     age: 15,
//   },
//   {
//     id: 7,
//     username: "Clifford",
//     email: "aaaa@gmail.com",
//     // status: "passive",
//     age: 44,
//   },
//   {
//     id: 8,
//     username: "Francis",
//     email: "aaa@gmail.com",
//     // status: "active",
//     age: 36,
//   },
//   {
//     id: 9,
//     username: "Veronica",
//     email: "aaa@gmail.com",
//     // status: "pending",
//     age: 60,
//   },
//   {
//     id: 10,
//     username: "Maxim",
//     email: "aaa@gmail.com",
//     // status: "active",
//     age: 28,
//   },
// ];
